import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { motion } from 'framer-motion';

export default function FaqSection({ section }) {
  const { title, data = {} } = section;
  const items = data.items || [];
  if (items.length === 0) return null;

  return (
    <section className="py-12 sm:py-16" data-testid="section-faq">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.35 }}
        >
          {title && <h2 className="font-display text-xl sm:text-2xl font-medium tracking-[-0.015em] text-ink mb-6">{title}</h2>}
          <Accordion type="single" collapsible className="space-y-2">
            {items.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border border-stone/50 rounded-lg px-4 bg-white">
                <AccordionTrigger className="text-sm font-medium text-ink hover:no-underline py-4">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-muted-foreground leading-relaxed pb-4">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
